import { render, staticRenderFns } from "./DashBoardWalletActivitiesView.vue?vue&type=template&id=2753a8ee&scoped=true&"
import script from "./DashBoardWalletActivitiesView.vue?vue&type=script&lang=js&"
export * from "./DashBoardWalletActivitiesView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardWalletActivitiesView.vue?vue&type=style&index=0&id=2753a8ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753a8ee",
  null
  
)

export default component.exports